import Quagga from 'quagga'

class BarcodeScanner {
  constructor(document) {
    this.document = document
    this.handler = undefined
  }

  openScannerForField = function(onDetectCallback, onCloseCallback) {
    let lastCode
    let attempts = 0
    Quagga.init(
      {
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          target: document.getElementById('scanner-container'),
          constraints: {
            width: 1024,
            height: 768,
            facingMode: 'environment',
          },
        },
        numOfWorkers: 4,
        locate: true,
        decoder: {
          readers: [
            'code_128_reader',
            'ean_reader',
            'ean_8_reader',
            'code_39_reader',
            'code_39_vin_reader',
            'codabar_reader',
            'upc_reader',
            'upc_e_reader',
            'i2of5_reader',
            '2of5_reader',
          ],
          halfSample: true,
          debug: {
            drawBoundingBox: true,
            showFrequency: true,
            drawScanline: true,
            showPattern: true,
          },
        },
      },
      err => {
        if (err) {
          // console.log(err);
          return
        }
        Quagga.start()
      }
    )

    Quagga.onProcessed(result => {
      let drawingCtx = Quagga.canvas.ctx.overlay
      let drawingCanvas = Quagga.canvas.dom.overlay

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(
            0,
            0,
            parseInt(drawingCanvas.getAttribute('width')),
            parseInt(drawingCanvas.getAttribute('height'))
          )
          result.boxes
            .filter(box => {
              return box !== result.box
            })
            .forEach(box => {
              Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                color: 'green',
                lineWidth: 2,
              })
            })
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
            color: '#00F',
            lineWidth: 2,
          })
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(
            result.line,
            { x: 'x', y: 'y' },
            drawingCtx,
            { color: 'red', lineWidth: 3 }
          )
        }
      }
    })

    this.handler = function(result) {
      if (result.codeResult.code === lastCode) attempts++
      else {
        lastCode = result.codeResult.code
        attempts = 0
      }
      if (attempts === 3) {
        onDetectCallback(result.codeResult.code)
        onCloseCallback()
      }
    }
    Quagga.onDetected(this.handler)
  }

  closeScanner = function() {
    Quagga.stop()
    Quagga.offDetected(this.handler)
  }
}

export function createBarcodeScanner(document) {
  return new BarcodeScanner(document)
}

export function isMobile() {
  return window.screen.width <= 1024
}
